import pluralize from 'pluralize'
import sweetAlert from 'src/bmAlert'

export class DeclineSubmissionsHelper {
  static async showDeactivateRequestSweetAlert(
    reservedPostCreditsCount: number = 0,
    multipassCreditReserved: number = 0
  ): Promise<boolean> {
    const returningCredits = this.getReservedKeywordCredits(
      reservedPostCreditsCount,
      multipassCreditReserved
    )
    let initialMessage = 'Are you sure?'
    if (returningCredits > 0) initialMessage = `You'll get back ${returningCredits} credits.`

    return sweetAlert.confirm({
      title: 'Deactivate Request?',
      text: `${initialMessage} You may reactivate this request at any time by visiting your <b>Inactive Requests</b>.`,
      confirmButtonText: 'Deactivate',
      cancelButtonText: 'Cancel',
    })
  }

  static async showDeclineInactiveSubmissionsSweetAlert(queuedCount: number): Promise<boolean> {
    return sweetAlert.confirm({
      title: 'Decline remaining submissions?',
      text: `There ${queuedCount > 1 ? 'are' : 'is'} <b>${queuedCount}</b> ${pluralize(
        'submission',
        queuedCount
      )} for this request waiting in your queue. Would you like Verblio to automatically decline them?`,
      confirmButtonText: 'Yes, decline',
      cancelButtonText: 'No, do nothing',
      customClass: {
        title: 'w-100',
        htmlContainer: 'text-left',
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-secondary ml-2',
        actions: 'justify-content-start',
      },
    })
  }

  static getReservedKeywordCredits(
    reservedPostCreditsCount: number,
    multipassCreditReserved: number
  ): number {
    if (multipassCreditReserved > 0) return multipassCreditReserved
    return reservedPostCreditsCount
  }
}
